module.exports = __webpack_public_path__ + "static/media/Llama Costume Girl.a9d72ab7.jpg";